import Graticule from './graticule.component';
export default Graticule;
